import { lazy, useState } from "react";
import { SectionHead, Reveal } from "./Reveal";
import { LazyCanvas } from "@/components/three/LazyCanvas";
import { PAIRS } from "@/data/site";

const PortalScene = lazy(() => import("@/components/three/PortalScene"));
const OPTIONS = ["car", "moto", "dirt", "person"];

export const PortalSection = () => {
  const [pair, setPair] = useState("car");
  const p = PAIRS[pair];
  return (
    <section id="portal" data-testid="portal-section" className="relative py-20 lg:py-28 overflow-hidden">
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-[700px] w-[700px] rounded-full bg-[#3b4049]/15 blur-[160px] pointer-events-none" />
      <div className="relative max-w-[1440px] mx-auto px-5 sm:px-8">
        <SectionHead center eyebrow="The shift" title={<>One world in.<br />Another world out.</>}>
          Your subject stays exactly the same. Everything around it changes the moment it passes through the frame.
        </SectionHead>

        <div className="relative rounded-2xl panel overflow-hidden">
          <div className="grid grid-cols-2 absolute top-0 inset-x-0 z-10 p-5 sm:p-7 pointer-events-none">
            <div>
              <div className="label-mono !text-slate-300">Original</div>
              <div className="font-display text-lg sm:text-2xl mt-2">{p.from}</div>
            </div>
            <div className="text-right">
              <div className="label-mono">Shifted</div>
              <div className="font-display text-lg sm:text-2xl mt-2">{p.to}</div>
            </div>
          </div>
          <LazyCanvas
            Scene={PortalScene}
            pair={pair}
            testId="portal-3d-canvas"
            className="h-[420px] sm:h-[520px] lg:h-[600px]"
            fallback={<img src={p.after} alt="" className="h-full w-full object-cover opacity-60" />}
          />
          <Reveal className="absolute bottom-5 sm:bottom-7 inset-x-0 z-10 flex justify-center">
            <div className="glass rounded-xl p-1.5 flex gap-1 max-w-[calc(100vw-48px)] overflow-x-auto" data-testid="portal-interactive-toggle">
              {OPTIONS.map((k) => (
                <button
                  key={k}
                  data-testid={`portal-toggle-${k}`}
                  onClick={() => setPair(k)}
                  className={`shrink-0 px-3.5 sm:px-6 py-2.5 rounded-lg text-sm font-medium transition-[background-color,color] duration-300 ${
                    pair === k ? "bg-[#3b4049] text-white shadow-[0_0_24px_rgba(190,197,208,0.7)]" : "text-slate-300 hover:text-white"
                  }`}
                >
                  {PAIRS[k].tag}
                </button>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
